// Smart date entry for the Identity Theft Report fields: the user types digits, separators are
// inserted automatically. Parts have no leading zeros (9/15/2026, as printed in the original),
// so a part is closed as soon as it is unambiguous: "9" -> "9/", "1" waits, "13" -> "1/3".
// Typed separators close the current part explicitly; leading zeros are dropped ("09" -> "9/").

const PARTS = {
  M: {max: 12},
  D: {max: 31},
  h: {max: 12},
  YYYY: {len: 4},
  YY: {len: 2},
  mm: {len: 2},
  A: {meridiem: true},
};

export const DATE_INPUT_FORMATS = {
  "M/D/YYYY": [["M", "/"], ["D", "/"], ["YYYY", ""]],
  "M/YYYY": [["M", "/"], ["YYYY", ""]],
  "M/D/YY, h:mm A": [["M", "/"], ["D", "/"], ["YY", ", "], ["h", ":"], ["mm", " "], ["A", ""]],
};

/**
 * Formats raw input for the given format key.
 * typing=false (the user is deleting) keeps an automatic trailing separator from being re-added,
 * so backspace over "9/" leaves "9" instead of snapping back to "9/".
 */
export function formatDateInput(raw, formatKey, typing = true) {
  const format = DATE_INPUT_FORMATS[formatKey];
  if (!format) return raw;
  const done = []; // [value, separator]
  let buffer = "";

  const close = (value) => {
    done.push([value, format[done.length][1]]);
    buffer = "";
  };
  const stripZeros = (s) => s.replace(/^0+(?=\d)/, "");

  const feed = (c) => {
    if (done.length >= format.length) return;
    const p = PARTS[format[done.length][0]];
    if (p.meridiem) {
      if (/[ap]/i.test(c)) close(c.toUpperCase() + "M");
      return;
    }
    if (!/\d/.test(c)) {
      if (buffer) close(stripZeros(buffer));
      return;
    }
    if (p.len) {
      buffer += c;
      if (buffer.length === p.len) close(buffer);
      return;
    }
    if (!buffer) {
      if (c !== "0" && Number(c) * 10 > p.max) close(c);
      else buffer = c;
      return;
    }
    if (buffer === "0") {
      if (c !== "0") close(c);
      return;
    }
    const candidate = buffer + c;
    if (Number(candidate) <= p.max) {
      close(candidate);
    } else {
      close(buffer);
      feed(c);
    }
  };

  String(raw).split("").forEach(feed);

  let out = done.map(([v, sep]) => v + sep).join("") + buffer;
  if (!typing && !buffer && done.length && done.length < format.length) {
    const sep = done[done.length - 1][1];
    if (!String(raw).endsWith(sep)) out = out.slice(0, out.length - sep.length);
  }
  return out;
}
